import OurArtists from './OurArtists';
import BackToTop from './BackToTop';
import Intro from './Intro';
import IntroImages from './IntroImages';
import Header from './Header';
import Block from './Block';
import SideMenu from './SideMenu';
import Video from './Video';
import MobileHeader from './MobileHeader';

const components = {
  OurArtists,
  BackToTop,
  Intro,
  IntroImages,
  Header,
  Block,
  SideMenu,
  Video,
  MobileHeader
}

export default components;
